import React from 'react';
import { TbNetworkOff } from 'react-icons/tb';
import { LuRefreshCw } from "react-icons/lu";

function FetchError({ error }) {
    return (
        <div className="w-full py-10 flex flex-col items-center justify-center text-center">
            <div className="relative mb-6">
                <div className="absolute inset-0 bg-error/10 blur-2xl rounded-full" />
                <div className="relative h-16 w-16 bg-surface-container-high rounded-2xl border border-error/20 flex items-center justify-center text-error shadow-inner">
                    <TbNetworkOff size={32} />
                </div>
            </div>

            <div className="space-y-2 max-w-md">
                <h3 className="text-[10px] font-black uppercase tracking-[0.3em] text-error/80">
                    Connection Diagnostic
                </h3>
                <h2 className="text-2xl font-headline font-black text-on-surface tracking-tight">
                    System Synchronization Failed
                </h2>
                <p className="text-on-surface-variant text-sm font-medium leading-relaxed italic">
                    "{error?.message || "An unexpected technical disruption occurred while fetching architectural data."}"
                </p>
            </div>

            <button
                onClick={() => window.location.reload()}
                className="mt-8 flex items-center gap-2 px-6 py-3 bg-surface-container-high hover:bg-outline-variant/20 text-on-surface text-[10px] font-black uppercase tracking-widest rounded-xl border border-outline-variant/10 transition-all active:scale-95"
            >
                <LuRefreshCw size={14} />
                Retry Connection
            </button>

            <div className="mt-8 h-px w-24 bg-gradient-to-r from-transparent via-outline-variant/30 to-transparent" />
        </div>
    );
}

export default FetchError;